import { render } from "./LeitnerSingleBox.vue?vue&type=template&id=2feae010&scoped=true&ts=true"
import script from "./LeitnerSingleBox.vue?vue&type=script&lang=ts"
export * from "./LeitnerSingleBox.vue?vue&type=script&lang=ts"

import "./LeitnerSingleBox.vue?vue&type=style&index=0&id=2feae010&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2feae010"]])

export default __exports__